import { TCustomerAddress } from 'modules/customer/types'
import { OrderCargoInfo, OrderCreateCargo, OrderCreateCargoTotal, OrderCreateRequest, OrderItemClient } from 'schema'

import { OrderCreateOperationForm } from '../components/OrderCreatePointOperation/types'
import { RadioSwitchValue, TOrderCreatePoint } from './orderCreateTypes'

export const WhoIsPayerType = {
  customer: 'customer',
  departurePartner: 'departurePartner',
  destinationPartner: 'destinationPartner',
  another: 'another'
} as const

export const DataSourceType = {
  auto: 'auto',
  user: 'user'
} as const

export type TOrderGuestCreatorDocument = {
  /** Номер документа */
  number: string
  /** Серия документа */
  series: string
  /** Тип документа */
  type: string
}

export type TOrderGuestCreateCreator = {
  /** Имя */
  firstname: string
  /** Фамилия */
  lastname: string
  /** Телефон для логина */
  phone: string
  /** Документ, удостоверяющий личность заказчика (физ.лицо) */
  document?: TOrderGuestCreatorDocument
  /** Отчество */
  secondname?: string
}

type TOrderGuestCreateCreatorForm = Partial<Omit<TOrderGuestCreateCreator, 'document'>> & {
  document?: Partial<TOrderGuestCreatorDocument>
}

export type TOrderGuestCreateCompany = {
  /** Источник данных (user - поля с адресом (address) заполнил пользователь, auto - поля с адресом (legalAddress) заполнены без участия пользователя) */
  dataSource: Values<typeof DataSourceType>
  /** ИНН */
  inn: string
  /** Наименование */
  name: string
  /** Юридический адрес (обязательное поле при dataSource = user) */
  address?: TCustomerAddress
  /** КПП. Обязательно у не ИП (длина ИНН = 10), не указывается у ИП (длина ИНН = 12) */
  kpp?: string
  /** Юридический адрес (обязательное поле при dataSource = auto) */
  legalAddress?: string
}

export type TOrderGuestCreateClient = {
  /** Тип клиента */
  type: OrderItemClient.type
  /** Юридический адрес контрагента */
  address?: TCustomerAddress
  /** Данные компании */
  company?: TOrderGuestCreateCompany | undefined
  /** Доступны ли контрагенту старые ВГХ при оформлении груза */
  hasSpecialCargoLimits?: boolean
}

export type TOrderGuestCreateContact = {
  /** Имя */
  firstname: string
  /** Фамилия */
  lastname: string
  /** Номер телефона */
  phone: string
  /** Добавочный номер телефона */
  phoneExt: string
  /** Отчество */
  secondname: string
}

export type TOrderGuestCreateCargo = OrderCreateCargo
export type TOrderGuestCreateCargoForm = TOrderGuestCreateCargo & {
  customHeight: number
  customLength: number
  customWeight: number
  customWidth: number
  palletHeight: number
  palletLength: number
  palletWeight: number
  palletWidth: number
}
export type TOrderGuestCreateCargoTotal = OrderCreateCargoTotal
type TOrderGuestCreateCustomerForm = Partial<TOrderGuestCreateClient>
export type TOrderGuestCreatePayer = {
  /** Кто выступает в роли плательщика */
  role: Values<typeof WhoIsPayerType>
}
export type TOrderGuestCreatePartner = TOrderGuestCreateClient & {
  contact: TOrderGuestCreateContact
}
export type TOrderGuestCreatePartnerForm = TOrderGuestCreateClient & {
  contact?: Partial<TOrderGuestCreateContact>
  isUser?: Values<typeof RadioSwitchValue>
  name?: string
}

export type IOrderCreateRequest = OrderCreateRequest

export type IOrderCreateFormData = Partial<{
  cargo: TOrderGuestCreateCargoForm[]
  cargoTotal: OrderCreateCargoTotal
  cargoType: OrderCargoInfo['type']
  comment: string
  creator: TOrderGuestCreateCreatorForm
  customer: TOrderGuestCreateCustomerForm
  departureDate: string
  departurePartner: TOrderGuestCreatePartnerForm
  departurePoint: TOrderCreatePoint
  destinationPartner: TOrderGuestCreatePartnerForm
  destinationPoint: TOrderCreatePoint
  isAgreeOffer: boolean
  operation: OrderCreateOperationForm[]
}>
